import { type ReactElement, useEffect, useMemo, useRef } from 'react'

type CycleComponentsContainerProps = {
  children: ReactElement[]
  storageKey?: string
}

/**
 * Will show one of the provided children, changing which one is displayed each time the user returns to the page
 * Currently intended for use with Banners on the AI profiles landing page (cycling to avoid users tuning the banners out)
 */
export const CycleComponentsContainer = ({
  children,
  storageKey = DEFAULT_KEY,
}: CycleComponentsContainerProps) => {
  const visits = useMemo(() => getPageVisitCount(storageKey), [storageKey])
  const hasUpdatedLocalStorageRef = useRef(false)

  useEffect(() => {
    // Hackily avoid React double-calling effect on local...
    if (hasUpdatedLocalStorageRef.current === false) {
      hasUpdatedLocalStorageRef.current = true
      localStorage.setItem(storageKey, `${getPageVisitCount(storageKey) + 1}`)
    }
  }, [storageKey])

  if (!children?.length) {
    return null
  }

  return children[visits % children.length] ?? null
}

const getPageVisitCount = (storageKey: string) => Number(localStorage.getItem(storageKey) ?? '0')

export const DEFAULT_KEY = 'lok-cycle-components-page-visit-count'
